export const uiTranslations = {
  en: () =>
    import(/* webpackPrefetch: true */ './en.json').then(translations => ({
      en: translations.default,
    })),
  de: () => import('./de.json').then(translations => ({ de: translations.default })),
  fr: () => import('./fr.json').then(translations => ({ fr: translations.default })),
  nl: () => import('./nl.json').then(translations => ({ nl: translations.default })),
  se: () => import('./se.json').then(translations => ({ se: translations.default })),
};
